<!--
  @Description: 公司-关注
  @Author: wang.y 
  @Date: 2022-02-25 
-->
<template>
  <div>
    <div class="hava-data">
      <div class="left">
        <Spin fix v-if="loading1">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <div class="content">
          <template v-if="atten_comp_list.length">
            <div class="sec-title"><span>关注一览</span></div>
            <entity-temp v-for="(item, index) in atten_comp_list" :key="'gz' + item.id" :item="item" :entitytype="0" :class="{ active: active_id == item.id }"></entity-temp>
          </template>
          <div class="sec-title sec-title-2"><span>推荐关注</span></div>
          <entity-temp v-for="(item, index) in $parent.comp_reco_list" :key="'tj' + item.id" :item="item" :entitytype="0" :class="{ active: active_id == item.id }"></entity-temp>
        </div>
      </div>
      <div class="right">
        <Spin fix v-if="loading">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <div class="comp-detail">
          <div class="sec-title-r">
            <span>公司研究</span>
            <div class="line"></div>
            <div class="lookmore" @click="$parent.goEntityDetail(0, active_uid)">
              查看更多
            </div>
          </div>
          <div class="research">
            <div class="top">
              <div class="compitem">
                <div class="logoimg">
                  <img :src="comp_detail.logo | logo_show" />
                </div>
                <div class="entity-info">
                  <div class="top">{{ comp_detail.shortName }}</div>
                  <div class="bottom">{{ comp_detail.entityDescription }}</div>
                </div>
              </div>
              <div class="logo">
                <img :src="$store.state.static_img_url + 'pic/logo.png'" />
                <p>提供数据支持</p>
              </div>
            </div>
            <div class="detail-tab">
              <div class="li-head">
                <div>企业名称</div>
                <div>成立时间</div>
                <div>地区</div>
                <div>最新融资轮次</div>
                <div>金额</div>
                <div>投资方</div>
              </div>
              <div class="li-body">
                <div>
                  <p class="over-p1">{{ comp_detail.fullName }}</p>
                </div>
                <div>
                  <p class="over-p1">
                    {{ comp_detail.setupTime | time_moment }}
                  </p>
                </div>
                <div>
                  <p class="over-p1">
                    {{ comp_detail.addressId | addressDeal("2") }}
                  </p>
                </div>
                <div>
                  <p class="over-p1">
                    {{ comp_detail.companyEventInfo.roundId | deal("round") }}
                  </p>
                </div>
                <div>
                  <p class="over-p1">
                    {{
                      comp_detail.companyEventInfo.amount
                        | amountPrecise(
                          comp_detail.companyEventInfo.unitId,
                          comp_detail.companyEventInfo.precise
                        )
                    }}
                  </p>
                </div>
                <div>
                  <p class="over-p1">
                    {{ comp_detail.companyEventInfo.faName }}
                  </p>
                </div>
              </div>
            </div>
            <div class="compdesc">{{ comp_detail.summary }}</div>
            <div class="bottom">
              <div class="lt">
                <div class="title">公司画像</div>
                <div class="cnt">
                  <div class="li" v-for="(item, index) in tag_list" :key="index">
                    <div class="li-name">
                      {{ index | deal("dynview_tag_type") }}
                    </div>
                    <div class="li-cnt">
                      <template v-for="(item2, index2) in item">
                        <span :key="item2.id" v-if="index2 < 3">{{
                          item2.name
                        }}</span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rt">
                <div class="title">融资经历及发展历程</div>
                <Table :columns="event_columns" :data="comp_detail.companyEventInfoList">
                  <template slot-scope="{ row }" slot="time">
                    {{ row.eventTime | time_moment }}
                  </template>
                  <template slot-scope="{ row }" slot="round">
                    {{ row.roundId | deal("round") }}
                  </template>
                  <template slot-scope="{ row }" slot="amount">
                    {{ row.amount | amountPrecise(row.unitId, row.precise) }}
                  </template>
                  <template slot-scope="{ row }" slot="tzf">
                    <div class="over-p1">{{ row.faName }}</div>
                  </template>
                </Table>
              </div>
            </div>
          </div>
        </div>
        <div class="comp-detail">
          <div class="sec-title-r">
            <span>公司对比</span>
            <div class="line"></div>
            <div class="lookmore" @click="haddleMoreCompare">查看更多</div>
          </div>
          <div class="detail-container">
            <div class="search">
              <div class="sea-comp">
                <Input prefix="ios-search" v-model="search_key" @on-change="handleChangeSearch" @on-focus="search_list_show = true" @on-blur="handleFocusSearch" placeholder="选择三家公司进行对比" />
                <div class="search-list" v-if="search_key && search_list_show">
                  <div class="nothing" v-if="search_list.length == 0 && !search_loading">
                    没有找到相关的内容
                  </div>
                  <Spin class="search-loading" v-if="search_loading">
                    <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
                    <div>Loading</div>
                  </Spin>
                  <template v-if="search_list.length > 0 && !search_loading">
                    <div class="search-item" v-for="(item, index) in search_list" :key="index" @click="addCompare(item)">
                      <div class="logo_img">
                        <img :src="item.logo_path | logo_show" />
                      </div>
                      <div class="entity-name over-p2">
                        {{ item.short_name }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="sel-comp">
                <div>
                  <span>{{ comp_detail.shortName }}</span>
                </div>
                <div v-for="item in compare_list" :key="item.id">
                  <span>{{ item.short_name }}</span>
                  <i class="iconfont" @click="handleRemove(item)">&#xe6c2;</i>
                </div>
              </div>
            </div>
            <!-- <div class="btn" @click="handleCompare" onclick="_czc.push(['_trackEvent', '我的关注(新)', '关注的公司(公司对比_对比)', '点击量'])">对比</div> -->
          </div>
          <table class="contrast-container" v-if="com_list.length">
            <tr>
              <th>公司名称</th>
              <td v-for="item in com_list" :key="item.uid">
                <div class="comp">
                  <div class="logoimg">
                    <img :src="item.logo_path | logo_show" />
                  </div>
                  <div class="entity-info over-p1">{{ item.short_name }}</div>
                </div>
              </td>
            </tr>
            <tr v-for="(prop, index) in dynview_tag_type" :key="index">
              <th>{{ prop.name }}</th>
              <td v-for="item in com_list" :key="item.uid">
                <div class="tags">
                  <template v-for="item2 in item.tags">
                    <div class="tag" v-if="type_bl(item2, prop.id)" :key="item2">
                      {{ item2 | deal("dynview_tag") }}
                    </div>
                  </template>
                </div>
              </td>
            </tr>
          </table>
          <div class="more-contrast" @click="haddleMoreCompare" v-if="com_list.length">
            查看更多
          </div>
        </div>
      </div>
    </div>
    <div class="data-list">
      <div class="sec-title-r">
        <span>公司动态-{{ comp_detail.shortName }}</span>
        <div class="line"></div>
      </div>
      <div class="list-wrap">
        <div class="item-list" v-for="(item, index) in dynamic_list" :key="index">
          <div class="legend">
            <div class="type">{{ typelist[item.content_type] }}</div>
            <div class="list-title-large" @click="$parent.goToDetail(item)" onclick="_czc.push(['_trackEvent', '我的关注(新)', '关注的公司(公司动态_每一条内容)', '点击量'])">
              {{ item.title }}
            </div>
            <div class="time" v-if="item.content_type == 3 && item.sort_time">{{ item.sort_time | time_moment}}更新</div>
            <div class="time" v-else>{{ item.publish_time | time_moment}}</div>
          </div>
        </div>
        <Spin fix v-if="loading3">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
      <div class="list-page" v-if="!(page1 == 1 && dynamic_list.length < 5)">
        <span :class="{ dis: page1 == 1 }" @click="handleChangePage('prev')">上一页</span>
        <span :class="{ dis: dynamic_list.length < 5 }" @click="handleChangePage('next')">下一页</span>
      </div>
      <div class="list-over" v-if="!loading3 && dynamic_list.length == 0">
        <template v-if="page1 == 1">暂无公司动态</template>
        <template v-else>已全部加载完</template>
      </div>
    </div>
    <div class="data-list">
      <div class="sec-title-r">
        <span>相关赛道动态-{{ comp_detail.shortName }}</span>
        <div class="line"></div>
        <div class="lookmore" @click="$parent.handleChangeRouter('trackList')" onclick="_czc.push(['_trackEvent', '我的关注(新)', '关注的公司(相关赛道动态_更多)', '点击量'])">
          查看更多
        </div>
      </div>
      <div class="list-wrap">
        <div class="item-list-wider" v-for="(item, index) in dynamic_list2" :key="index">
          <div class="legend">
            <div class="type">{{ typelist[item.content_type] }}</div>
            <div class="list-title-large" @click="$parent.goToDetail(item)" onclick="_czc.push(['_trackEvent', '我的关注(新)', '关注的公司(相关赛道动态_每一条内容)', '点击量'])">
              {{ item.title }}
            </div>
            <div class="time" v-if="item.content_type == 3 && item.sort_time">{{ item.sort_time | time_moment}}更新</div>
            <div class="time" v-else>{{ item.publish_time | time_moment}}</div>
          </div>
          <div class="list-tag">
            <div class="name">相关赛道</div>
            <template v-for="(item2, index2) in item.app_tag_arr">
              <div class="tag" :key="index2" @click="$parent.goToTrackDetail(item2)" v-if="index2 < 3">
                {{ item2 | dealName($parent.entity_ntag) }}
              </div>
            </template>
          </div>
        </div>
        <Spin fix v-if="loading4">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
      <div class="list-page" v-if="!(page2 == 1 && dynamic_list2.length < 5)">
        <span :class="{ dis: page2 == 1 }" @click="handleChangePage2('prev')">上一页</span>
        <span :class="{ dis: dynamic_list2.length < 5 }" @click="handleChangePage2('next')">下一页</span>
      </div>
      <div class="list-over" v-if="!loading4 &&dynamic_list2.length == 0">
        <template v-if="page2 == 1">暂无相关赛道动态</template>
        <template v-else>已全部加载完</template>
      </div>
    </div>
  </div>
</template>
<script>
import {
  findEntity,
  commonCompanyDetail,
  entityCompare,
  searchForEntity,
  switchFocusCompany,
  switchFocusTrack,
  entityDetail,
  subscribeOverview
} from '@/service'
import { dynview_tag_mixins } from 'js/dynview_tag_mixins'
import EntityTemp from './EntityTemp2'
export default {
  mixins: [dynview_tag_mixins],
  components: {
    EntityTemp,
  },
  created() {
    if (this.atten_comp_ids.length) this.handleFindEntity('0', this.atten_comp_ids)
  },
  mounted() {},
  data() {
    return {
      loading1: true,
      loading: true,
      loading3: true,
      loading4: true,
      active_id: '',
      atten_comp_list: [],
      event_columns: [
        {
          title: '时间',
          slot: 'time',
          width: 100,
        },
        {
          title: '轮次',
          slot: 'round',
          width: 70,
        },
        {
          title: '金额',
          slot: 'amount',
          width: 100,
        },
        {
          title: '投资方/并购方',
          slot: 'tzf',
        },
      ],
      comp_detail: {
        companyEventInfo: {},
      },
      is_init: true,
      tag_list: {},
      com_list: [],
      active_uid: '',
      compare_list: [],
      search_key: '',
      search_loading: true,
      search_list: [],
      search_list_show: false,
      uid_list: [],
      page1: 1,
      dynamic_list: [],
      page2: 1,
      dynamic_list2: [],
      typelist: {
        0: '文章',
        1: '视频',
        2: '报告',
        3: '专题Pro',
        4: '快讯',
      },
      competitor_list: [],
    }
  },
  computed: {
    dynview_tag_type() {
      return this.$store.state.dynview_tag_type.filter((item) => item.id < 3)
    },
    dynview_tag() {
      return this.$store.state.dynview_tag
    },
    type_bl() {
      return function (data_id, type_id) {
        let index = this.new_tags.findIndex((a) => {
          return a.id == data_id
        })
        if (index > -1) {
          if (this.new_tags[index].type_id == type_id) {
            return true
          } else {
            return false
          }
        }
      }
    },
    attention() {
      return this.$store.state.attention || {}
    },
    atten_comp() {
      let arr = this.attention.subscribe.filter((a) => a.sub_type == '0')
      return arr
    },
    atten_comp_ids() {
      let ids = []
      this.atten_comp.forEach((a) => {
        ids.push(a.sub_type_id)
      })
      return ids
    },
  },
  watch: {
    atten_comp_ids(arr) {
      if (arr.length) {
        this.handleFindEntity('0', arr)
      } else {
        this.atten_comp_list = []
      }
    },
  },
  methods: {
    /**
     * 获取实体信息
     * @param
     * stype 实体类型 0公司 1机构 (必传)
     * arr 实体id数组
     * keyword 关键字检索
     */
    async handleFindEntity(stype) {
      let res = await subscribeOverview(
        {
          type: stype
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        this.$set(this.$data, 'atten_comp_list', res.data.res)
        console.log(this.atten_comp_list)
        this.loading1 = false
        if (this.is_init) {
          this.is_init = false
          if (res.data.res.length) {
            this.active_id = res.data.res[0].id
            this.active_uid = res.data.res[0].uid
          } else {
            this.active_id = this.$parent.comp_reco_list[0].id
            this.active_uid = this.$parent.comp_reco_list[0].uid
          }
          this.getCompDetail(this.active_id)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getCompDetail(id) {
      this.loading = true
      this.page1 = 1
      this.page2 = 1
      this.switchFocusCompany()
      this.switchFocusTrack()
      this.getCompetitor()
      this.tag_list = {}
      let res = await commonCompanyDetail(
        {
          companyId: id,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.success) {
        this.$set(this.$data, 'comp_detail', res.data)
        let arr = this.$store.state.dynview_tag.filter((a) => {
          let index = res.data.companyTagInfoList.findIndex((b) => b.tagId == a.id)
          return index > -1
        })
        arr.forEach((a) => {
          let item
          if (a.pgid == null && a.pid == null) {
            item = this.$store.state.dynview_tag.find((b) => b.id == a.id)
          } else if (a.pgid == null && a.pid != null) {
            item = this.$store.state.dynview_tag.find((b) => b.id == a.pid)
          } else if (a.pgid != null && a.pid != null) {
            item = this.$store.state.dynview_tag.find((b) => b.id == a.pgid)
          }
          if (!this.tag_list[item.type_id]) {
            this.tag_list[item.type_id] = [a]
          } else {
            this.tag_list[item.type_id].push(a)
          }
        })
      } else {
        this.loading = false
        this.$Message.error(res.message)
      }
    },
    async getCompetitor() {
      let res = await entityDetail(
        {
          uid: this.active_uid,
          type: 'competitor',
          entity_type: 0,
          page: 1,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'compare_list', res.rival_comps.slice(0, 2))
        this.handleCompare()
      } else {
        this.loading = false
        this.$Message.error(res.msg)
      }
    },
    async handleCompare() {
      this.uid_list = [this.active_uid]
      this.compare_list.forEach((item) => {
        this.uid_list.push(item.uid)
      })
      let res = await entityCompare(
        {
          uids: this.uid_list,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      this.loading = false
      if (res.status == 'success') {
        this.$set(this.$data, 'com_list', res.res)
      } else {
        this.$Message.error(res.msg)
      }
    },
    haddleMoreCompare() {
      _czc.push(['_trackEvent', '我的关注(新)', '关注的公司(公司对比_更多/查看更多)', '点击量'])
      const { href } = this.$router.resolve({
        name: 'CompanyCompare',
        query: { uids: this.uid_list },
      })
      window.open(href, '_blank')
    },
    async handleChangeSearch() {
      this.search_loading = true
      let res = await searchForEntity(
        {
          user_key: this.$store.state.user_key,
          keyword: this.search_key,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.status == 'success') {
        this.$set(this.$data, 'search_list', res.res)
        this.search_loading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    handleFocusSearch() {
      setTimeout(() => {
        this.search_list_show = false
      }, 500)
    },
    addCompare(item) {
      if (this.compare_list.length == 2) {
        this.$Message.info('最多添加两家公司')
        return
      }
      let index = this.compare_list.findIndex((a) => a.id == item.id)
      if (index == -1) {
        this.compare_list.push(item)
        this.handleCompare()
      } else {
        this.$Message.info('该公司已添加')
      }
    },
    handleRemove(item) {
      let index = this.compare_list.findIndex((a) => a.id == item.id)
      if (index > -1) {
        this.compare_list.splice(index, 1)
        this.handleCompare()
      }
    },
    handleChangePage(type) {
      _czc.push(['_trackEvent', '我的关注(新)', '关注的公司(公司动态_翻页控件)', '点击量'])
      if (!this.loading3) {
        if (type == 'next') {
          if (this.dynamic_list.length == 5) {
            this.page1++
            this.switchFocusCompany()
          }
        } else {
          if (this.page1 > 1) {
            this.page1--
            this.switchFocusCompany()
          }
        }
      }
    },
    handleChangePage2(type) {
      _czc.push(['_trackEvent', '我的关注(新)', '关注的公司(相关赛道动态_翻页控件)', '点击量'])
      if (!this.loading4) {
        if (type == 'next') {
          if (this.dynamic_list2.length == 5) {
            this.page2++
            this.switchFocusTrack()
          }
        } else {
          if (this.page2 > 1) {
            this.page2--
            this.switchFocusTrack()
          }
        }
      }
    },
    async switchFocusCompany() {
      this.loading3 = true
      let res = await switchFocusCompany(
        {
          page: this.page1,
          size: 5,
          id: this.active_id,
          uid: this.active_uid,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      this.loading3 = false
      if (res.code == '0') {
        this.$set(this.$data, 'dynamic_list', res.data)
      } else {
        this.$Message.error(res.msg)
      }
    },
    async switchFocusTrack() {
      this.loading4 = true
      let res = await switchFocusTrack(
        {
          page: this.page2,
          size: 5,
          id: this.active_id,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      this.loading4 = false
      if (res.code == '0') {
        this.$set(this.$data, 'dynamic_list2', res.data)
      } else {
        this.$Message.error(res.msg)
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
.hava-data
  .right
    position relative
  .left
    position relative
    .content
      background #F8F9FA
      padding 16px 20px
      overflow auto
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      &::-webkit-scrollbar-track
        background-color #F8F9FA !important
      &::-webkit-scrollbar
        background-color #F8F9FA !important
      &::-webkit-scrollbar-thumb
        background-color #999 !important
    >>> .entity-temp
      height 60px
      cursor pointer
      &:hover
        border-color #ff8824
      & + div
        margin-top 16px
  .comp-detail
    background #f8f9fa
    padding 16px 20px
    &+.comp-detail
      margin-top 12px
    .research
      background #fff
      padding 10px
      > .top
        display flex
        justify-content space-between
        .compitem
          flex 1
          display flex
          .logoimg
            flex 0 0 60px
            height 60px
            background #fff
            display flex
            align-items center
            justify-content center
            border 1px solid #EEEEEE
            img
              max-height 100%
              max-width 100%
          .entity-info
            line-height 1
            margin-left 12px
            display flex
            flex-direction column
            justify-content center
            .top
              font-size 26px
              font-weight bold
            .bottom
              font-size 16px
              color #999
              margin-top 12px
        .logo
          display flex
          flex-direction column
          align-items flex-end
          justify-content center
          img
            height 28px
          p
            margin-top 12px
            font-size 12px
            color #999999
      > .detail-tab
        margin-top 10px
        .li-head, .li-body
          display grid
          grid-template-columns repeat(6, 1fr)
          grid-template-rows 26px
          grid-column-gap 2px
          div
            display flex
            justify-content center
            align-items center
        .li-head
          div
            background-color #FF8824
            color #fff
        .li-body
          p
            padding 0 6px
          div
            background-color #FFF1E6
            color #FF8824
      .compdesc
        margin-top 10px
        line-height 18px
      > .bottom
        margin-top 10px
        border-top 1px solid #eee
        padding-top 10px
        display flex
        > .lt
          flex 0 0 360px
          .cnt
            padding-top 20px
          .li
            display flex
            &+.li
              margin-top 16px
          .li-name
            color #999
            flex 0 0 58px
            line-height 24px
            font-size 12px
          .li-cnt
            flex 1
            display flex
            flex-wrap wrap
            margin 0 0 -10px 0
            span
              padding 0 10px
              height 24px
              background #FFF1E6
              display flex
              align-items center
              color #ff8824
              margin 0 10px 10px 0
        > .rt
          flex 1
          >>> .ivu-table-wrapper
            margin-top 12px
            .ivu-table
              tr
                th
                  height 30px
                  .ivu-table-cell
                    font-size 13px
                    font-weight normal
                    color #666
                  &:first-of-type
                    .ivu-table-cell
                      padding-left 10px
                td
                  padding 10px 0
                  line-height 16px
                  &:first-of-type
                    .ivu-table-cell
                      padding-left 10px
        .title
          font-size 13px
          color #333
          position relative
          line-height 1
          z-index 1
          width max-content
          &:before
            content ''
            position absolute
            background #ffba80
            height 6px
            width 100%
            bottom -2px
            z-index -1
    .detail-container
      display flex
      justify-content space-between
      align-items center
      .search
        display flex
        .sea-comp
          position relative
          >>> .ivu-input-wrapper
            .ivu-input
              height 24px
              width 165px
              border 0
              background none
              border-radius 0
              border-bottom 1px solid #ff8824
              box-shadow none
              outline none
              &::-webkit-input-placeholder
                color: #999
            .ivu-input-prefix
              i
                line-height 24px
                color #ff8824
          .search-list
            position absolute
            width 200px
            max-height 200px
            overflow auto
            background #fff
            padding 6px 0
            margin-top 6px
            z-index 10
            box-shadow 2px 2px 4px rgba(0, 0, 0, 0.1)
            .search-loading
              color #ff8824
            .nothing
              text-align center
              color #999
              font-size 12px
            .search-item
              display flex
              padding 5px 12px
              cursor pointer
              &:hover
                background #fffaf5
              .logo_img
                flex 0 0 40px
                height 40px
                display flex
                justify-content center
                align-items center
                border 1px solid #eee
                background #fff
                img
                  max-width 100%
                  max-height 100%
              .entity-name
                margin-left 10px
                flex 1
                display flex
                align-items center
                line-height 18px
      .btn
        background #FF8824
        font-size 14px
        line-height 1
        padding 5px 10px
        color #FFFFFF
        cursor pointer
      .sel-comp
        display flex
        align-items center
        > div
          display flex
          align-items center
          padding 0 10px
          height 24px
          border 1px solid #FF8824
          color #FF8824
          line-height 1
          margin-left 12px
          cursor pointer
          span
            white-space nowrap
          .iconfont
            font-size 12px
            transform scale(0.8)
            margin-left 8px
            margin-top 1px
    .contrast-container
      margin-top 20px
      th
        width 104px
        background #FFFAF5
        font-size 14px
        color #666666
        font-weight normal
        height 50px
        font-size 14px
        border 1px solid #F3F3F3
      td
        padding 16px
        border 1px solid #F3F3F3
        font-size 14px
        width 230px
        background #fff
        .tags
          display flex
          flex-wrap wrap
          margin -10px -10px 0 0
          .tag
            background #f5f5f5
            color #666
            padding 6px 10px
            border-radius 2px
            line-height 1
            margin 10px 10px 0 0
      .comp
        display flex
        align-items center
        .logoimg
          flex 0 0 40px
          height 40px
          background #fff
          display flex
          align-items center
          justify-content center
          img
            max-height 100%
            max-width 100%
        .entity-info
          color #666
          margin-left 6px
    .more-contrast
      margin-top 16px
      width 100%
      display flex
      align-items center
      justify-content center
      height 36px
      border 1px solid #FF8824
      line-height 1
      color #FF8824
      cursor pointer
      &:hover
        background-color #FF8824
        color #fff
.sec-title, .sec-title-r
  line-height 1
  padding-bottom 16px
  font-size 16px
  display flex
  align-items center
  justify-content space-between
  span
    padding-right 20px
.sec-title-r
  .line
    flex 1
    border-top 1px solid #e9e9e9
  .lookmore
    color #FF8824
    margin-left 20px
    font-size 14px
    cursor pointer
.sec-title
  &:after
    content ''
    flex 1
    border-top 1px solid #e9e9e9
  &-2
    &:after
      border-top 1px dashed #e9e9e9
.data-list
  background #f8f9fa
  padding 16px 20px
  margin-top 12px
  .list-over
    text-align: center
    color #999
    padding 10px 0
  .list-wrap
    position relative
    display flex
    flex-direction column
    border-left 2px solid #F3F3F3
    .ivu-spin-fix
      left -2px
      background-color #f8f9fa
    
    .item-list
      position relative
      left -2px
      // height fit-content
    .item-list-wider
      margin-bottom 10px
      position relative
      left -2px
    .item-list
      margin-bottom 20px
    .legend
      display flex
      // justify-content space-between
      .type
        height 18px
        line-height 18px
        font-size 12px
        color #FFFFFF
        padding 0 10px
        background #ff8824
        margin-right 8px
        white-space: nowrap;
      .list-title-large
        font-size 14px
        color #333333
        line-height 18px
        // margin-left 15px
        // margin-top 15px
        cursor pointer
        &:hover
          color #FF8824
      .time
        height 12px
        font-size 12px
        color #999999
        line-height 18px
        margin-left auto
        white-space: nowrap;
    .list-title
      font-size 14px
      color #333333
      line-height 18px
      // margin-left 15px
      // margin-top 15px
      margin-bottom 15px
    .list-tag
      margin-top 10px
      padding 0 15px
      display flex
      align-items center
      .name
        font-size 12px
        color #999999
      .tag
        display flex
        height 26px
        background #FFF4EA
        border-radius 13px
        align-items center
        margin-left 10px
        padding 0 10px
        font-size 12px
        color #FF8824
        cursor pointer
        &:hover
          color #fff
          background #FF8824
  .list-page
    display flex
    justify-content center
    // margin-top 10px
    span
      line-height 1
      cursor pointer
      color #ff8824
      &.dis
        color #999
      &+span
        margin-left 10px
</style>